var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseDoi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 110,
    viewBox: "0 0 159 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.269 42.657L75.668 5H47.402l-42.4 37.657H33.27z",
    fill: "#E40051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.856 67.075c2.665 6.281 14.922 11.13 22.17 0",
    stroke: "#000",
    strokeWidth: 7.538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.665 5L33.266 42.657M75.666 5l42.398 37.657V78.71M75.665 5H47.4L5 42.657m28.266 0v62.106m0-62.106H5m28.266 62.106h84.798V78.71m-84.798 26.053H5V42.657M118.064 78.71c4.9.84 10.176-.565 13.003-4.263",
    stroke: "#000",
    strokeWidth: 8.582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.996,
    cy: 54.882,
    r: 5.542,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.884,
    cy: 54.882,
    r: 5.542,
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDE5F5",
    d: "M136.438 39.398l17.473 4.682-8.193 30.58-17.474-4.683z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.249 69.977l17.474 4.682 2.548-9.508-17.474-4.682-2.548 9.508z",
    fill: "#BDE5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 8.582,
    strokeLinejoin: "round",
    d: "M136.438 39.398l17.473 4.682-8.193 30.58-17.474-4.683z"
  })));
}
export default SvgHouseDoi;